import React from "react";
import NoData from "../../NoData";
import {withTranslate} from "react-redux-multilingual";


const BranchDaysList = ({currentBranchDays, styles, currentDay, setCurrentDay, translate, language}) => {
    const branchesDaysList = currentBranchDays && currentBranchDays.length ? currentBranchDays.map((day, index) => {
            return (
                <div key={index} className="day-card" onClick={(e) => setCurrentDay(day, e)}>
                    <div className="day-card-body" style={language === "ar" ? {width: "100px"} : {width: "65px"}}>
                        <span className="day-name">{day.day}&nbsp;</span>
                        <hr />
                        <span className="day-number">{day.day_number}&nbsp;</span>
                        <span className="month">{day.month}</span>
                    </div>
                </div>
            )
        }
    ) : (<NoData image="no-doctors"/>);

    return (
        <div className="days-wrapper"
             style={styles.slideInRight}>
            <div className="display-flex" style={{justifyContent: "space-between"}}>
                {/*<i className="fas fa-calendar-alt"></i>*/}
                <p className="choose-days-title margin-bottom-10">
                    <span className="bolder">{translate("choose_day")}</span>
                </p>
                <span>{currentDay ? currentDay.date : null}</span>
            </div>
            <div className="flex-container">
                {branchesDaysList}
            </div>
        </div>

    )
};


export default withTranslate(BranchDaysList);